// @ts-nocheck
import React from 'react'
import PropTypes from 'prop-types'
import { capitalize } from 'lodash'
import { isBrowser, isTablet } from 'react-device-detect'
import { css, StyleSheet } from 'aphrodite/no-important'
import { colors } from '@lmc/common/constants'
import { GlyphButton as OldGlyphButton } from '../../../LEGACY/elemental'
import { Spinner } from '@lmc/ui-kit'
import { Link } from 'react-router-dom'

import { hexToRgbA } from '../../../common/utils'

export default function GlyphButton({
  className,
  disabled,
  glyph,
  glyphSize,
  loading,
  id,
  link,
  position,
  onClick,
  style,
  text,
  type = 'edit'
}) {
  const isDesktop = isBrowser || isTablet
  const displayText = text || capitalize(type)
  const commonStyles = {
    color: colors.black,
    textShadow: 'none !important',
    transition: 'all .3s ease'
  }

  const boxShadow = '0 2px 4px rgba(34,34,34,0.15)'
  const boxShadowLight = '0 2px 4px rgba(34,34,34,0.05)'
  const classes = StyleSheet.create({
    add: {
      ...commonStyles,
      background: `${colors.successgreen}!important`,
      color: 'white !important',
      ':hover': {
        background: `${colors.successgreen}!important`,
        boxShadow,
        color: 'white !important'
      },
      ':focus': {
        boxShadow: boxShadowLight,
        color: 'white !important'
      }
    },
    confirm: {
      ...commonStyles,
      background: `${colors.green}!important`,
      color: 'white !important',
      ':hover': {
        background: `${colors.green}!important`,
        boxShadow,
        color: 'white !important'
      },
      ':focus': {
        boxShadow: boxShadowLight,
        color: 'white !important'
      }
    },
    draft: {
      ...commonStyles,
      background: colors.orange,
      color: 'white',
      textShadow: 'none',
      ':hover': {
        background: colors.orange,
        boxShadow,
        color: 'white'
      },
      ':focus': {
        boxShadow: boxShadowLight,
        color: 'white'
      }
    },
    delete: {
      ...commonStyles,
      background: 'Transparent',
      textShadow: 'none',
      ':hover': {
        background: colors.red,
        boxShadow,
        color: 'white'
      },
      ':focus': {
        boxShadow: boxShadowLight,
        color: 'white'
      }
    },
    discontinue: {
      ...commonStyles,
      background: colors.red,
      textShadow: 'none',
      ':hover': {
        background: `${hexToRgbA(colors.red, 0.8)}`,
        boxShadow,
        color: 'white'
      },
      ':focus': {
        boxShadow: boxShadowLight,
        color: 'white'
      }
    },
    cancel: {
      ...commonStyles,
      background: colors.grey,
      textShadow: 'none',
      ':hover': {
        background: colors.lightgrey,
        boxShadow
      },
      ':focus': {
        boxShadow: boxShadowLight,
        color: colors.darkgrey
      }
    },
    edit: {
      ...commonStyles,
      background: `${colors.successgreen}!important`,
      textShadow: 'none',
      ':hover': {
        background: `${colors.successgreen}!important`,
        boxShadow
      },
      ':focus': {
        boxShadow: boxShadowLight
      }
    },
    back: {
      ...commonStyles,
      background: 'Transparent',
      color: colors.red,
      ':hover': {
        color: colors.red
      }
    },
    success: {
      background: `${colors.successgreen}!important`,
      color: 'white !important',
      ':hover': {
        background: `${colors.successgreen}!important`,
        boxShadow,
        color: 'white !important'
      },
      ':focus': {
        boxShadow: boxShadowLight,
        color: 'white !important'
      }
    },
    resend: {
      ...commonStyles,
      background: `${colors.grey}!important`,
      color: disabled ? colors.white : colors.black,
      ':hover': {
        background: `${colors.lightgrey}!important`,
        boxShadow
      },
      ':focus': {
        boxShadow: boxShadowLight
      }
    }
  })

  return (
    <OldGlyphButton
      className={className}
      component={link ? Link : null}
      disabled={disabled}
      id={id || null}
      glyph={glyph || GLYPHS[type]}
      glyphSize={glyphSize}
      onClick={onClick || null}
      position={position || isDesktop ? 'left' : 'default'}
      style={style}
      to={link || null}
    >
      <span>{isDesktop && !loading ? displayText : null}</span>
      {loading ? (
        <Spinner
          size="small"
          color={['cancel'].includes(type) ? '#ccc' : 'white'}
        />
      ) : null}
    </OldGlyphButton>
  )
}

const GLYPHS = {
  add: 'plus',
  back: 'chevron-left',
  cancel: 'x',
  confirm: 'check',
  delete: 'trashcan',
  draft: 'pencil',
  edit: 'pencil'
}

GlyphButton.propTypes = {
  className: PropTypes.string,
  disabled: PropTypes.bool,
  id: PropTypes.string,
  glyph: PropTypes.string,
  glyphSize: PropTypes.string,
  link: PropTypes.string,
  position: PropTypes.string,
  loading: PropTypes.bool,
  onClick: PropTypes.func,
  style: PropTypes.object,
  text: PropTypes.string,
  type: PropTypes.oneOf([
    'add',
    'cancel',
    'confirm',
    'delete',
    'discontinue',
    'draft',
    'edit',
    'back',
    'success',
    'resend'
  ])
}
